import ApiError from 'src/api/ApiError';

type ValidError = ApiError | Error | string;

// TODO support sx
interface Props {
  error?: ValidError | null;
  // errors?: ValidError[]; TODO implement
  fontSize?: string;
  mt?: number;
  mb?: number;
}
const ErrorMessage: React.FC<Props> = ({ error, fontSize, mt, mb }) => {
  if (!error) {
    return null;
  }

  const message = typeof error === 'string' ? error : error.message;
  const displayMessage = message?.trim() || 'An unexpected error occurred';

  return (
    <p
      className="text-center text-red-600"
      style={{
        fontSize: fontSize || '16px',
        marginTop: mt != null ? `${mt * 8}px` : undefined,
        marginBottom: mb != null ? `${mb * 8}px` : undefined,
      }}
    >
      {displayMessage}
    </p>
  );
};

export default ErrorMessage;
